import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { forwardRef } from "react";

export type GridGap = "none" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
export type GridCols = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
  gap?:
    | GridGap
    | {
        x?: GridGap;
        y?: GridGap;
      };
  xs?: GridCols;
  sm?: GridCols;
  md?: GridCols;
  lg?: GridCols;
  xl?: GridCols;
}
const Grid = forwardRef<HTMLDivElement, GridProps>((props, ref) => {
  const {
    className,
    gap,
    xs = 12,
    sm = xs,
    md = sm,
    lg = md,
    xl = lg,
    ...rest
  } = props;
  return (
    <div
      {...rest}
      ref={ref}
      className={twMerge(
        clsx("grid", {
          "gap-1": gap === "xs",
          "gap-2": gap === "sm",
          "gap-3": gap === "md",
          "gap-4": gap === "lg",
          "gap-6": gap === "xl",
          "gap-8": gap === "2xl",
          "gap-x-1": typeof gap === "object" && gap.x === "xs",
          "gap-x-2": typeof gap === "object" && gap.x === "sm",
          "gap-x-3": typeof gap === "object" && gap.x === "md",
          "gap-x-4": typeof gap === "object" && gap.x === "lg",
          "gap-x-6": typeof gap === "object" && gap.x === "xl",
          "gap-x-8": typeof gap === "object" && gap.x === "2xl",
          "gap-y-1": typeof gap === "object" && gap.y === "xs",
          "gap-y-2": typeof gap === "object" && gap.y === "sm",
          "gap-y-3": typeof gap === "object" && gap.y === "md",
          "gap-y-4": typeof gap === "object" && gap.y === "lg",
          "gap-y-6": typeof gap === "object" && gap.y === "xl",
          "gap-y-8": typeof gap === "object" && gap.y === "2xl",
        }),
        `grid-cols-${xs}`,
        sm !== xs ? `sm:grid-cols-${sm}` : undefined,
        md !== sm ? `md:grid-cols-${md}` : undefined,
        lg !== md ? `lg:grid-cols-${lg}` : undefined,
        xl !== lg ? `xl:grid-cols-${xl}` : undefined,
        className
      )}
    />
  );
});

export default Grid;
